import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { SettingsContext } from "../context/settingsContext";

import {
  Icon,
  DataTable,
  DataTableColumn,
  DataTableCell,
  Checkbox,
  IconSettings,
} from "@salesforce/design-system-react";

const ToggleDataTableCell = ({ children, ...props }) => {
  const { toggleSetting } = useContext(SettingsContext);
  return (
    <DataTableCell {...props}>
      <Checkbox
        id={`checkbox-toggle-${props.property}-${props.item.id}`}
        variant="toggle"
        checked={children}
        onChange={() => toggleSetting(props.item.id, props.property)}
      />
    </DataTableCell>
  );
};
ToggleDataTableCell.displayName = DataTableCell.displayName;

const MappingConfigDataTableCell = ({ children, ...props }) => {
  return true ? (
    <DataTableCell {...props}>
      <Link to={`/mappings/${props.item.id}`}>Edit</Link>
    </DataTableCell>
  ) : (
    <DataTableCell {...props}>
      <Icon category="utility" name="lock" size="small" />
    </DataTableCell>
  );
};
MappingConfigDataTableCell.displayName = DataTableCell.displayName;

const RemoveConfigDataTableCell = ({ children, ...props }) => {
  const { removePluginObject } = useContext(SettingsContext);
  return (
    <DataTableCell {...props}>
      {props.item.removable ? (
        <a onClick={() => removePluginObject(props.item.id)}>Remove</a>
      ) : (
        <></>
      )}
    </DataTableCell>
  );
};
RemoveConfigDataTableCell.displayName = DataTableCell.displayName;

function SalesforceConfigTable(props) {
  const { pluginObjects } = useContext(SettingsContext);

  const columns = [
    <DataTableColumn key="object-name" label="Name" property="name" />,
    <DataTableColumn
      key="object-searchable"
      label="Visible in Search Results"
      property="searchable"
    >
      <ToggleDataTableCell />
    </DataTableColumn>,
    <DataTableColumn
      key="object-creatable"
      label="Show Create Action"
      property="creatable"
    >
      <ToggleDataTableCell />
    </DataTableColumn>,
    <DataTableColumn
      key="object-editable"
      label="Mapping Configuration"
      property="editable"
    >
      <MappingConfigDataTableCell />
    </DataTableColumn>,
    <DataTableColumn key="object-removable" label="Action" property="removable">
      <RemoveConfigDataTableCell />
    </DataTableColumn>,
  ];

  return (
    <IconSettings iconPath="/icons">
      <DataTable items={pluginObjects} id="SettingsObjectDataTable">
        {columns}
      </DataTable>
    </IconSettings>
  );
}

export default SalesforceConfigTable;
